import { MDBAlert, MDBBtn, MDBIcon } from "mdbreact"
import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Container, Form, Input, Label, Media, Row, Table } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"
import { TIEMPO_MOSTRAR_ERROR } from "../../ayudas/constantes"
import { TAMANIO_IMG_COLUMNAS_LG, TAMANIO_IMG_COLUMNAS_SM, TAMANIO_IMG_COLUMNAS_XS } from "../../ayudas/constantes";
import { obtener_formulario_omitiendo_imagenes_ya_guardadas } from "../../ayudas/funciones"
import Lightbox from 'react-image-lightbox';
import Select from 'react-select';

export default class MaterialFormulario extends React.Component {

    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);

        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
                es_material: true,
                codigo: "",
                nombre: "",
                marca: "",
                serie: "",
                descripcion: "",
                tipo_cuenta_contable: "",
                precio: 0.0,
                costo: 0.0,
                tipo: 1,
                vendible: false,
                estado: 3,
                //fecha_compra: null,
                cantidad: 1,
                tipo_ingreso: 1,
                taza_depreciacion: 0,
                observaciones: "",
                img_articulo: null,
                //proveedor: undefined,
            },
            colapsar: true,
            colapsarAsociarCategoria: true,
            colapsarAsociarEmpresa: true,
            camposRequeridos: [],
            categorias: [],
            empresas: [],
            proveedores: [],
            imgNuevaArticuloBase64: null,
            verImagenEnGrande: false,
        };
        this.colapsarTablaAsociar = this.colapsarTablaAsociar.bind(this);
        this.asociarCategoria = this.asociarCategoria.bind(this);
        this.asociarEmpresa = this.asociarEmpresa.bind(this);
        this.almacenarRegistro = this.almacenarRegistro.bind(this);
        this.datosRegistroValidos = this.datosRegistroValidos.bind(this);
        this.actualizarValores = this.actualizarValores.bind(this);
    }

    componentDidMount() {
        this.obtenerAsociados();
        this.getProveedor();
        let registro = this.state.registro
        if (_valid(registro.id)) {
            this.imagen("/getImagen/" + registro.id, "GET", " ").then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ imgNuevaArticuloBase64: resultado.imgNuevaBase64 });
                } else {
                    toastr.error('No hay imagen.');
                }
            });
        } else {

        }
    }

    //obtener proveedor
    getProveedor = () => {
        this.apiRest.get('/proveedor').then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ proveedores: respuesta.data });
            }
        });
    }

    imagen = async (url, method) => {
        return await fetch(process.env.REACT_APP_API_URL + url, {
            method: method
        })
            .then(async response => {
                if (response.status >= 200 && response.status < 300) {
                    return await response.json()
                        .then(dato => ({
                            exitoso: true,
                            data: dato.datosSerializados,
                            imgNuevaBase64: dato.imgNuevaArticuloBase64
                        }))
                        .catch(error => ({ exitoso: false, response, error }));
                } else if (response.status === 401) {
                    this.props.history.push('/logout');
                } else {
                    return await response.json()
                        .then(dato => ({ exitoso: false, response, data: dato }))
                        .catch(error => ({ exitoso: false, response, error }));
                }
            })
            .catch(error => ({ "exitoso": false, error }));
    }

    obtenerAsociados() {
        const { registro } = this.state;
        if (_valid(registro.id)) {
            this.apiRest.get('/articuloCategorias/' + registro.id).then(respuesta => {
                if (respuesta.exitoso) {
                    this.setState({ categorias: respuesta.data });
                }
            });
            this.apiRest.get('/articuloEmpresa/' + registro.id).then(respuesta => {
                if (respuesta.exitoso) {
                    this.setState({ empresas: respuesta.data });
                }
            });
        }
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    colapsarTablaAsociar = estadoAColapsar => {
        this.setState(estadoAnterior => ({ ...estadoAnterior, [estadoAColapsar]: !estadoAnterior[estadoAColapsar] }));
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: value }
        }));
    }

    asociarCategoria = ({ target: { name, value, checked } }) => {
        const datos = {
            asociar: checked,
            idCategoria: value
        }
        this.apiRest.put('/asociarArticuloCategoria/' + this.state.registro.id, datos).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Categoria ' + (checked ? 'asociado' : 'desasociado') + ' exitosamente!');
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    asociarEmpresa = ({ target: { name, value, checked } }) => {
        const datos = {
            asociar: checked,
            idEmpresa: value
        }
        this.apiRest.put('/asociarArticuloEmpresa/' + this.state.registro.id, datos).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Empresa ' + (checked ? 'asociado' : 'desasociado') + ' exitosamente!');
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    almacenarRegistro = async () => {
        if (this.datosRegistroValidos()) {
            const registro = this.state.registro;
            let datosFormulario = new FormData();
            datosFormulario = obtener_formulario_omitiendo_imagenes_ya_guardadas(registro, "img_articulo");
            if (_valid(registro.id)) {
                this.apiRest.ArticuloFile('/articuloEditar/' + registro.id, datosFormulario, "PUT").then(resultado => {
                    if (resultado.exitoso) {
                        toastr.success('Datos almacenados exitosamente!');
                        this.props.history.replace('/materialFormulario');
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            } else {
                this.postFileArticulo('/articulo', datosFormulario).then(resultado => {
                    if (resultado.exitoso) {
                        toastr.success('Datos almacenados exitosamente!');
                        this.setState({ registro: resultado.data });
                        this.setState({ imgNuevaArticuloBase64: resultado.imgNuevaBase64 });
                        this.obtenerAsociados();

                        this.props.history.replace('/materialListado');
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            }
        }
    }

    postFileArticulo(url, data) {
        return this.postArticuloFile(url, 'POST', data);
    }

    async postArticuloFile(url, method, data) {
        const auth = this.apiRest.getLS('authUser');
        const headers = {
            method: method,
            headers: { 'Authorization': 'Bearer ' + auth.access },
            body: data
        }

        return await fetch(process.env.REACT_APP_API_URL + url, headers)
            .then(async response => {
                if (response.status >= 200 && response.status < 300) {
                    return await response.json()
                        .then(dato => ({
                            exitoso: true,
                            data: dato.datosSerializados,
                            imgNuevaBase64: dato.imgNuevaArticuloBase64
                        }))
                        .catch(error => ({ exitoso: false, response, error }));
                } else if (response.status === 401) {
                    this.props.history.push('/logout');
                } else {
                    return await response.json()
                        .then(dato => ({ exitoso: false, response, data: dato }))
                        .catch(error => ({ exitoso: false, response, error }));
                }
            })
            .catch(error => ({ "exitoso": false, error }));
    }

    datosRegistroValidos() {
        const {
            codigo,
            nombre,
            tipo, estado,
            img_articulo,
            cantidad,
            tipo_ingreso,
            fecha_compra,
            proveedor
        } = this.state.registro;

        let contador = 0

        const { camposRequeridos } = this.state;
        if (!_valid(codigo)) {
            camposRequeridos.push("codigo");
        } else {
            contador += 1;
        }
        if (!_valid(nombre)) {
            camposRequeridos.push("nombre");
        } else {
            contador += 1;
        }
        if (!_valid(tipo)) {
            camposRequeridos.push("tipo");
        } else {
            contador += 1;
        }
        /*if (!_valid(fecha_compra)) {
            camposRequeridos.push("fecha de compra");
        }*/
        /*if (!_valid(img_articulo)) {
            camposRequeridos.push("imagen");
        } else {
            contador += 1;
        }*/
        /*if (!_valid(tipo_ingreso)) {
            camposRequeridos.push("tipo de ingreso");
        } else {
            contador += 1;
        }*/
        /*if (!_valid(proveedor)) {
            camposRequeridos.push("proveedor");
        } else {
            contador += 1;
        }*/

        this.setState({ camposRequeridos: camposRequeridos });
        setTimeout(() => this.setState({ camposRequeridos: [] }), TIEMPO_MOSTRAR_ERROR);

        if (contador === 3) {
            return true
        } else {
            return false;
        }
    }

    //imagen articulo
    actualizarImagen = ({ target: { name, files } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: files[0] }
        }));
    }


    actualizarPagina = () => {
        const {
            registro
        } = this.state
        for (const property in registro) {
            this.setState(estadoAnterior => ({
                registro: {
                    ...estadoAnterior.registro, [property]: ''
                }
            }));
        }
        this.setState(
            { imgNuevaArticuloBase64: null }
        )

    }

    render() {
        const {
            registro,
            colapsar,
            colapsarAsociarCategoria,
            colapsarAsociarEmpresa,
            camposRequeridos,
            categorias,
            empresas,
            imgNuevaArticuloBase64,
            verImagenEnGrande,
            proveedores
        } = this.state;

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Mesa de Servicio " breadcrumbItem="Material" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark" to="#">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Material</h5>
                                                        <p className="text-muted text-truncate mb-0">Por favor, proporciona los datos.</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <div className="p-4 border-top">
                                                <Form>
                                                    <div>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="codigo" className="form-label">
                                                                        Código
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.codigo}
                                                                        onChange={this.actualizarValores}
                                                                        name="codigo"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa codigo"
                                                                        required={true}
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="nombre" className="form-label" >
                                                                        Nombre
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.nombre}
                                                                        onChange={this.actualizarValores}
                                                                        name="nombre"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa nombre"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="marca" className="form-label">
                                                                        Marca
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.marca}
                                                                        onChange={this.actualizarValores}
                                                                        name="marca"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa marca"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="serie" className="form-label">
                                                                        Serie
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.serie}
                                                                        onChange={this.actualizarValores}
                                                                        name="serie"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa serie"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="descripcion" className="form-label">
                                                                        Descripción
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.descripcion}
                                                                        onChange={this.actualizarValores}
                                                                        name="descripcion"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa descripcion"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="tipo_cuenta_contable" className="form-label">
                                                                        Tipo cuenta contable
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.tipo_cuenta_contable}
                                                                        onChange={this.actualizarValores}
                                                                        name="tipo_cuenta_contable"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa el tipo de cuenta contable"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="precio" className="form-label">
                                                                        Precio
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.precio}
                                                                        onChange={this.actualizarValores}
                                                                        name="precio"
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder="Ingresa tu precio"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="costo" className="form-label">
                                                                        Costo
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.costo}
                                                                        onChange={this.actualizarValores}
                                                                        name="costo"
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder="Ingresa tu costo"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="tipo" className="form-label">
                                                                        Tipo
                                                                    </Label>
                                                                    <select
                                                                        value={registro.tipo}
                                                                        onChange={this.actualizarValores}
                                                                        name="tipo"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="1">Fijo</option>
                                                                        <option value="2">Funjible</option>
                                                                        <option value="3">Inventarible</option>
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        {
                                                            /*<Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="tipo" className="form-label">
                                                                        Estado
                                                                    </Label>
                                                                    <select
                                                                        value={registro.estado}
                                                                        onChange={this.actualizarValores}
                                                                        name="estado"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="0">No Asignado</option>
                                                                        <option value="3">Almacenado</option>
                                                                        <option value="4">Entregado</option>
                                                                        <option value="5">Rechazado</option>
                                                                        <option value="6">Aceptado</option>
                                                                        <option value="7">Parcialmente Aceptado</option>
                                                                        <option value="8">No aceptado</option>
                                                                        <option value="9">En Mantenimiento</option>
                                                                        <option value="10">De baja</option>
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="tipo_ingreso" className="form-label">
                                                                        Tipo de Ingreso
                                                                    </Label>
                                                                    <select
                                                                        value={registro.tipo_ingreso}
                                                                        onChange={this.actualizarValores}
                                                                        name="tipo_ingreso"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="0">Seleccionar</option>
                                                                        <option value="1">Compra</option>
                                                                        <option value="2">Ajuste de Inventario</option>
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="cantidad" className="form-label">
                                                                        Cantidad
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.cantidad}
                                                                        onChange={this.actualizarValores}
                                                                        name="cantidad"
                                                                        min="0"
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder="Ingresa la cantidad"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            </Row>
                                                            <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="fecha_compra" className="form-label">
                                                                        Fecha de Compra
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.fecha_compra}
                                                                        onChange={this.actualizarValores}
                                                                        name="fecha_compra"
                                                                        type="date"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="taza_depreciacion" className="form-label">
                                                                        Taza de Depreciaci&oacute;n
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.taza_depreciacion}
                                                                        onChange={this.actualizarValores}
                                                                        name="taza_depreciacion"
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder="Ingresa la cantidad"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <Label htmlFor="proveedor" className="form-label">
                                                                    Proveedor
                                                                </Label>
                                                                <select
                                                                    value={registro.proveedor}
                                                                    onChange={this.actualizarValores}
                                                                    name="proveedor"
                                                                    className="form-control"
                                                                >
                                                                    <option value="0">Seleccionar</option>
                                                                    {proveedores.map(item => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                                                                </select>
                                                            </Col>
                                                        </Row>
                                                        */
                                                        }
                                                        <Row>
                                                            <Col lg={8}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="observaciones" className="form-label">
                                                                        Observaciones
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.observaciones}
                                                                        onChange={this.actualizarValores}
                                                                        name="observaciones"
                                                                        type="textarea"
                                                                        className="form-control"
                                                                        placeholder="observaciones"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="img_articulo" className="form-label">
                                                                        Subir imagen
                                                                    </Label>
                                                                    <input
                                                                        name="img_articulo"
                                                                        className="form-control"
                                                                        type="file"
                                                                        onChange={this.actualizarImagen}
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={TAMANIO_IMG_COLUMNAS_LG} sm={TAMANIO_IMG_COLUMNAS_SM} xs={TAMANIO_IMG_COLUMNAS_XS}>
                                                                <Label htmlFor="img_articulo" className="form-label">
                                                                    Imagen
                                                                </Label>
                                                                <div onClick={() => this.setState({ verImagenEnGrande: true })}>
                                                                    {imgNuevaArticuloBase64 && <img width="100%" src={`data:image/jpeg;base64,${imgNuevaArticuloBase64}`} alt="articulo" />}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    &nbsp;
                                                    <Row>
                                                        {_valid(camposRequeridos) && camposRequeridos.map((campo, index) => <MDBAlert key={index} color="danger"><strong>{campo}</strong> es requerido.</MDBAlert>)}
                                                    </Row>
                                                </Form>
                                            </div>
                                            <Row>
                                                <Col lg={12} className="text-end">
                                                    <MDBBtn className="waves-effect" color="danger" onClick={() => { this.props.history.replace('/materialListado') }}>
                                                        <MDBIcon icon="fas fa-arrow-left" />{' '}
                                                        Regresar
                                                    </MDBBtn>
                                                    {' '}
                                                    <MDBBtn className="waves-effect" color="success" onClick={() => this.almacenarRegistro()}>
                                                        <MDBIcon icon="fas fa-user-check" /> {' '}
                                                        Guardar
                                                    </MDBBtn>
                                                </Col>
                                            </Row>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        {
                            _valid(registro.id) &&
                            <Row>
                                <Col className="col-12">
                                    <Card>
                                        <CardBody>
                                            <Link onClick={() => this.colapsarTablaAsociar("colapsarAsociarCategoria")} className="text-dark">
                                                <div className="p-4">
                                                    <Media className="d-flex align-items-center">
                                                        <div className="me-3">
                                                            <i className="uil uil-receipt text-primary h2"></i>
                                                        </div>
                                                        <div className="flex-1 overflow-hidden">
                                                            <h5 className="font-size-16 mb-1">Asociar Categoria</h5>
                                                        </div>
                                                        <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                    </Media>
                                                </div>
                                            </Link>
                                            <Collapse isOpen={colapsarAsociarCategoria}>
                                                <div className="p-4 border-top">
                                                    <Table className="table table-sm m-0">
                                                        <thead>
                                                            <tr>
                                                                <th width="15%">Asociar</th>
                                                                <th>Categoria</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                categorias.map((categoria, indice) =>
                                                                    <tr key={indice}>
                                                                        <td className="text-center">
                                                                            <Input
                                                                                type="checkbox"
                                                                                value={categoria.id}
                                                                                onChange={this.asociarCategoria}
                                                                                defaultChecked={categoria.asociado}
                                                                                className="form-control"
                                                                            />
                                                                        </td>
                                                                        <td>{categoria.nombre}</td>
                                                                    </tr>
                                                                )
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </Collapse>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        }
                        {
                            _valid(registro.id) &&
                            <Row>
                                <Col className="col-12">
                                    <Card>
                                        <CardBody>
                                            <Link onClick={() => this.colapsarTablaAsociar("colapsarAsociarEmpresa")} className="text-dark">
                                                <div className="p-4">
                                                    <Media className="d-flex align-items-center">
                                                        <div className="me-3">
                                                            <i className="uil uil-receipt text-primary h2"></i>
                                                        </div>
                                                        <div className="flex-1 overflow-hidden">
                                                            <h5 className="font-size-16 mb-1">Asociar empresa</h5>
                                                        </div>
                                                        <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                    </Media>
                                                </div>
                                            </Link>
                                            <Collapse isOpen={colapsarAsociarEmpresa}>
                                                <div className="p-4 border-top">
                                                    <Table className="table table-sm m-0">
                                                        <thead>
                                                            <tr>
                                                                <th width="15%">Asociar</th>
                                                                <th>Empresa</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                empresas.map((empresa, indice) =>
                                                                    <tr key={indice}>
                                                                        <td className="text-center">
                                                                            <Input
                                                                                type="checkbox"
                                                                                value={empresa.id}
                                                                                onChange={this.asociarEmpresa}
                                                                                defaultChecked={empresa.asociado}
                                                                                className="form-control"
                                                                            />
                                                                        </td>
                                                                        <td>{empresa.nombre}</td>
                                                                    </tr>
                                                                )
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </Collapse>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        }
                    </Container>
                </div>
                {verImagenEnGrande && <Lightbox mainSrc={`data:image/jpeg;base64,${imgNuevaArticuloBase64}`} onCloseRequest={() => this.setState({ verImagenEnGrande: false })} />}
            </React.Fragment>
        );
    }
}